<template>
  <div class="column">
    <div class="col-auto">
      <div
        class="row items-center bg-grey-1 q-py-xs q-px-sm"
        v-if="showExitButton"
      >
        <div
          class="col text-left"
          style="height: 24px"
        >
          <VonixLogo class="logo" />
        </div>

        <div
          class="col"
          style="width: 27px; max-width: 27px"
        >
          <q-btn
            data-testid="teclado-sair"
            flat
            color="primary"
            size="12px"
            padding="7px"
            align="center"
            @click="handleExit"
          >
            <CloseWindowsIcon class="windowsIcon" />
          </q-btn>
        </div>
      </div>
    </div>

    <div class="col-auto">
      <div class="items-center bg-white keyboard">
        <Keyboard @on-key="handleDigit" />
      </div>
    </div>
  </div>
</template>

<script>
import Keyboard from './Keyboard'
import VonixLogo from '@/assets/icons/vonixLogo.svg'
import CloseWindowsIcon from '@/assets/icons/closeWindows.svg'
import { mapActions } from 'vuex'

export default {
  components: {
    Keyboard,
    VonixLogo,
    CloseWindowsIcon
  },

  props: {
    attendanceId: {
      type: String,
      required: false
    },

    showExitButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  methods: {
    ...mapActions({
      DTMFAudioPlay: 'sipModule/DTMFAudioPlay',
      sendDTMF: 'sipModule/sendDTMF',
      hangup: 'sipModule/hangup'
    }),

    handleDigit (key) {
      if (!key) return
      this.DTMFAudioPlay(key)
      this.sendDTMF({ tone: key, attendanceId: this.attendanceId })
    },

    handleExit () {
      this.hangup(this.attendanceId)
    }
  }
}
</script>

<style lang="sass" scoped>
  .keyboard
    overflow: hidden
    width: 186px !important

  .logo
    width: 19px
    height: 24px
</style>
